module.exports = __webpack_public_path__ + "img/gzh.024ae029.png";